import { applyTicketRebet, fillEmptyUnsubmittedTickets, countTickets } from "@/modules/commonMachineGame";
import { applyClearBet, applyClickUndo, applyCommonSubmitBet, clearBetHistory, getLastBetArray, getTicketTotalBet, IFetchPostDataType, isBetClosed, isDev, purgeApplyLastBet, recountTotal } from "@/modules/commonMobile";
import { setMessageModal, setBetConfirmedModal, clearModals } from "@/modules/modals";
import { getBasePcode, isMachineGame } from "@/modules/gamePcode";
import { IGameObjectType, IGameType, ILastBetType } from "@/types/GlobalTypes";
import Desktop from ".";

function changeChip(this: Desktop, e: React.MouseEvent) {
	const chipValue = Number(e.currentTarget.getAttribute("value"));
	this.setState({ chipValue });
}

function clearInvalidBets(this: Desktop, game: IGameType) {
	for (const betKeyGroupPair in game.bet) {
		const group = betKeyGroupPair.split("+")[1];

		if (group === "n50") {
			if (game.bet[betKeyGroupPair] < game.min50 ||
				game.bet[betKeyGroupPair] > game.max50)
				delete game.bet[betKeyGroupPair];
		} else {
			if (game.bet[betKeyGroupPair] < game.min ||
				game.bet[betKeyGroupPair] > game.max)
				delete game.bet[betKeyGroupPair];
		}
	}

	recountTotal(game);
}

// gameArray is optional, only used in clickClear
function insertBet(this: Desktop, e: any, gameArray?: IGameObjectType) {
	const isEvent = !!e.currentTarget;
	const pcode = !isEvent ? e.pcode : e.currentTarget.getAttribute("pcode");
	const timerObject = this.state.timers[pcode];

	const games = gameArray || this.state.games;
	const game = games[pcode];

	const forced = e.forced || false; // forces bet insertion

	//Toggles chip transparency when it's bet closed
	if (isBetClosed(timerObject.time)) {
		game.transparentChips = !game.transparentChips;
		this.setState({ games: games });
		return;
	}

	// Prevents clicking after click submit
	if (this.state.games[pcode].disallowInsertionAfterClickSubmit) {
		alert("Please wait for a moment...");
		return;
	}

	// Prevents bet insertion on bet close
	if (!forced && isBetClosed(timerObject.time))
		return;

	const chipValue = !isEvent ?
		Number(e.chipValue) :
		this.state.chipValue;



	// Checks insufficient user balance
	const userBalance = this.state.userdata.user.balance;

	const newTotalBet = game.lastSubmittedTotal ?
		game.totalBet - game.lastSubmittedTotal :
		game.totalBet;

	if (newTotalBet + chipValue > userBalance) {
		this.setState({ insufficientBalance: true });

		window.setTimeout((mainClass) => {
			mainClass.setState({ insufficientBalance: false });
		}, 500, this);
	}

	// Simplifies bet insertion
	if (!this.applyCommonInsertBet(chipValue, game, this.state.userdata, isEvent, e))
		return;

	this.checkController(game); // insertBet

	// Plays bet SFX
	if (!forced)
		this.playBetSFX();

	this.setState({ games: games }); // insertBet
}

function clickUndo(this: Desktop, e: React.MouseEvent) {
	const pcode = e.currentTarget.getAttribute("pcode");
	const { games } = this.state;
	const game = games[pcode];

	if (game.betHistory.length === 0)
		return;

	applyClickUndo(game);

	this.checkController(game); // clickUndo

	this.setState({ games }); // clickUndo
}

function clickClear(this: Desktop, e: any) {
	const
		isEvent = !!e.currentTarget,
		pcode = isEvent ? e.currentTarget.getAttribute("pcode") : e.pcode,
		lobby = this,
		{ games, userdata } = this.state,
		game = games[pcode];

	applyClearBet(game, () => {
		const filteredLastBet = getLastBetArray(userdata, pcode);
		purgeApplyLastBet(game, filteredLastBet);

		lobby.checkController(game); // clickClear

		// Plays Clear SFX
		if (game.active && !e.noSound)
			lobby.playClearSFX();

		lobby.setState({ games });
	});
}

function clickRebet(this: Desktop, e: any) {
	const lobby = this;
	const _games = this.state.games;
	const _timers = this.state.timers;

	const pcode = e.pcode || e.currentTarget.getAttribute("pcode");

	//Extra optional parameters (only for Chip restoration)
	const forced = e.forced || false;
	const noSFX = e.noSFX || false;
	const submitted = e.submitted || false;

	const game = _games[pcode];
	const basePcode = getBasePcode(pcode);
	const machineGame = isMachineGame(basePcode);

	// console.log("auto rebet?", this.state.autoRebet);

	// Applies tickets, else applies last bet
	if (machineGame) {
		applyTicketRebet(game);
	} else {
		const lastBetArray = getLastBetArray(this.state.userdata, pcode);

		if (isDev())
			console.log("cR lBA", lastBetArray);

		// purgeApplyLastBet(game, lastBetArray, true);

		// Use insertBet function to add chip additions into undo buffer
		if (lastBetArray.length > 0)
			lastBetArray.forEach((tebak: ILastBetType) => {
				this.insertBet({
					pcode: pcode,
					bet: tebak.tebak,
					group: tebak.type,
					chipValue: Number(tebak.taruhan),

					//Used in chip restoration
					forced: forced
				});
			});
	}

	window.setTimeout(() => {
		// Recounts total bet for machine games
		if (machineGame)
			game.totalBet = getTicketTotalBet(game);

		//Used in chip restoration
		if (submitted) {
			game.submitted = true;
			game.betHistory = [];
		}

		lobby.checkController(game); // clickRebet

		// Plays Rebet SFX
		if (!noSFX &&
			!isBetClosed(_timers[pcode].time))
			lobby.playRebetSFX();

		lobby.setState({ games: _games });
	}, 100);
}

function clickSubmit(this: Desktop, e: any) {
	const lobby = this;
	const pcode = e.pcode || e.currentTarget.getAttribute("pcode");
	const _games = this.state.games;
	const game = _games[pcode];
	const machineGame = isMachineGame(pcode);
	// const basePcode = getBasePcode(pcode);

	const fetchPostData: IFetchPostDataType = {
		total_bet: 0,
		button_bet: [],
		game: pcode,
		transId: ""
	};

	// Clears invalid bets
	// sanitiseBets(game);

	// Applies bet accumulation to submit
	applyCommonSubmitBet(game, fetchPostData);

	// Prohibits bet insertion before bet submission has finished
	game.disallowInsertionAfterClickSubmit = true;

	// Disables submit bet on first click
	game.disableSubmitBet = true;
	clearBetHistory(game); // clickSubmit

	let skipSubmit = false;

	// Show bet error (especially after invalid bet purging for machine games)
	if (fetchPostData.button_bet.length === 0) {
		setMessageModal(game, "Invalid bets have been removed. Please input your guess.");

		game.disallowInsertionAfterClickSubmit = false;
		clearBetHistory(game); // clickSubmit
		this.checkController(game); // clickSubmit

		// Fill empty tickets
		if (machineGame)
			fillEmptyUnsubmittedTickets(game);

		recountTotal(game);

		skipSubmit = true;
	}

	this.setState({ games: _games });

	if (skipSubmit)
		return;

	// Click submit simulator, won't interact with the database
	if (this.state.useTempData) {
		// const resdata = { status: true, message: "" };
		const resdata = { status: false, message: "BET CLOSED!!!!" };

		console.log("Simulating click submit...", "fPD:", fetchPostData);

		// Shows the modal
		if (resdata.status)
			setBetConfirmedModal(game);
		else setMessageModal(game, resdata.message.toUpperCase());

		clearBetHistory(game); // clickSubmit

		// Count tickets
		countTickets(game); // clickSubmit

		// Refreshes user data
		window.setTimeout(() => {
			// lobby.hideModal({ pcode: pcode });

			if (resdata.status)
				clearModals(_games[pcode]);

			lobby.fetchUserData(null);

			// Checks controller
			lobby.checkController(game); // clickSubmit

			lobby.setState({ games: _games });
		}, 1000);

		window.setTimeout(() => {
			game.disallowInsertionAfterClickSubmit = false;

			// Fill empty tickets
			if (machineGame)
				fillEmptyUnsubmittedTickets(game);

			recountTotal(game);

			// Simulate user balance (unused in live)
			const userdat = lobby.state.userdata;

			if (game.lastSubmittedTotal)
				userdat.user.balance -= game.totalBet - game.lastSubmittedTotal;
			else userdat.user.balance -= game.totalBet;
			// End of user balance simulation

			game.lastSubmittedTotal = game.totalBet;

			lobby.setState({
				games: _games,

				// Used in user balance simulation
				userdata: userdat
			});
		}, 1500);

		lobby.setState({ games: _games });
		
		return;
	}

	// Receive actual data from the server, using production build
	fetch("/games/send/send", {
		credentials: "same-origin",
		method: "POST",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json"
		},
		body: JSON.stringify(fetchPostData)
	})
		.then(res => res.json())
		.then((data: any) => {
			lobby.fetchUserData(null);
			if (data) {
				game.disallowInsertionAfterClickSubmit = false;

				// Shows the modal
				if (data.status)
					setBetConfirmedModal(game);
				else setMessageModal(game, data.message.toUpperCase());

				if (data.status) {
					clearBetHistory(game); // clickSubmit

					// Count tickets
					countTickets(game); // clickSubmit

					// Refreshes user data
					window.setTimeout(() => {
						//lobby.hideModal({ pcode: pcode });
						clearModals(game);

						// Fill empty tickets
						if (machineGame)
							fillEmptyUnsubmittedTickets(game);

						lobby.fetchUserData(null);

						recountTotal(game);

						// for use in insertBet
						game.lastSubmittedTotal = game.totalBet;

						// Checks controller
						lobby.checkController(game); // clickSubmit

						lobby.setState({ games: _games });
					}, 1200);
				} else {
					// Any bet failure
					// if (machineGame)
					// 	game.tickets = [];
					// else
					if (!machineGame) {
						const filteredLastBet = getLastBetArray(lobby.state.userdata, pcode);
						purgeApplyLastBet(game, filteredLastBet); // clickSubmit
					}

					recountTotal(game);
				}


				this.checkController(game);

				this.setState({ games: _games });
			}
		});
		
}

export {
	changeChip,
	clearInvalidBets,
	clickClear,
	clickRebet,
	clickSubmit,
	clickUndo,
	insertBet
}